import { Stack, useTheme } from '@mui/material';
import { ItemProgressType } from '@aibees/elephant/views/enrich-report-page-view/types';
import { classnames } from '@aibees/shared/utils';
import { memo } from 'react';
import * as Styled from './styles';
import * as SX from './sx';
import type { RecordsEnrichedProps as Props } from './types';
import { ItemProgress } from '../item-progress';
import { ItemCard } from '../item-card';

export const RecordsEnriched = memo(({ className }: Props) => {
  const { palette } = useTheme();

  const records: ItemProgressType[] = [
    {
      title: 'Total Rows',
      value: '1000',
      percent: '100',
      color: palette.primary[500],
    },
    {
      title: 'Matched',
      value: '945',
      percent: '94.5',
      color: palette.success[500],
    },
    {
      title: 'Failed',
      value: '25',
      percent: '2.5',
      color: palette.error[500],
    },
    {
      title: 'Duplicated',
      value: '30',
      percent: '3',
      color: palette.warning[500],
    },
  ];

  const totals: ItemProgressType[] = [
    {
      title: 'Total Fields Enriched',
      value: '23/2345',
      percent: '46',
      color: palette.common.black,
    },
    {
      title: 'Total Data Point',
      value: '465/576',
      percent: '46',
      color: palette.common.black,
    },
  ];

  return (
    <Styled.Wrapper
      className={classnames('RecordsEnriched', className)}
      sx={SX.root}
    >
      <ItemCard title="Records Enriched" creditCost="-5,285">
        <Stack sx={SX.records} gap={2.5}>
          {records.map((i) => (
            <ItemProgress key={i.title} item={i} />
          ))}
        </Stack>
        <Stack sx={SX.totals} gap={2.5}>
          {totals.map((i) => (
            <ItemProgress key={i.title} item={i} />
          ))}
        </Stack>
      </ItemCard>
    </Styled.Wrapper>
  );
});

RecordsEnriched.displayName = 'RecordsEnriched';
